module.exports = __webpack_public_path__ + "static/img/banner2.3b87b4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/banner2.png
// module id = xUzZ
// module chunks = 0